<!--<app-blackmonth></app-blackmonth>-->
<section class="banner-container">
  <div class="hero-banner">
    <div class="background"></div>
    <div
      class="background-logo"
      [style.background-image]="getBackgroundImage('object')"
    ></div>
    <div class="background-triangle"></div>
    <div class="background-triangle-bottom"></div>
    <div class="hero-wrapper">
      <div class="hero-content-row">
        <div class="hero-left">
          <h1>
            {{ "components.homePage.realEstateInvestment" | translate }}
            <br />
            {{ "components.homePage.withProfitabilityFrom" | translate }}
            <br />{{ "components.homePage.theFirstDay" | translate }}
          </h1>
          <div
            class="underline"
            [style.background-image]="getBackgroundImage('underline')"
          ></div>
          <div class="buy-rented-properties">
            <ul>
              <li>
                <img src="../../assets/icons/check.svg" alt="" />
                {{ "components.homePage.personalizedAdvice" | translate }}
              </li>
              <li>
                <img src="../../assets/icons/check.svg" alt="" />
                {{ "components.homePage.completeAssetPlanning" | translate }}
              </li>
              <li>
                <img src="../../assets/icons/check.svg" alt="" />
                {{ "components.homePage.fromRentedFlatsToLargeAssets" | translate }}
              </li>
              <li>
                <img src="../../assets/icons/check.svg" alt="" />
                {{ "components.homePage.weHandleRentalAndManagement" | translate }}
              </li>
            </ul>
          </div>
        </div>
        <div class="hero-right">
          <div class="video-caption">
            <p class="video-question">{{ "components.homePage.videoQuestion" | translate }}</p>
            <p class="video-subtitle">{{ "components.homePage.videoSubtitle" | translate }}</p>
          </div>
          <div class="video-wrapper">
            <video #homeVideo controls [muted]="true" playsinline preload="auto" controlsList="nodownload" class="hero-video" (canplay)="playVideo($event)">
              <source
                [src]="videoSrc"
                type="video/mp4"
              />
            </video>
            <button class="btn-agendar" (click)="openCallModal()">
              <i class="fa-regular fa-calendar"></i>
              {{ "components.homePage.scheduleConsultation" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="container-filter">
        <div class="card-filter">
          <app-home-filters></app-home-filters>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="page info-container">
  <article class="text-imgs-container">
    <div class="text">
      <div class="icon">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <h3>{{ "components.homePage.findYourInvestment" | translate }}</h3>
      <p>{{ "components.homePage.filterByProfitability" | translate }}</p>
      <p>{{ "components.homePage.inversionesPorDebajo" | translate }}</p>
      <app-investment-calculator></app-investment-calculator>
    </div>

    <div class="image-container">
      <img
        src="../../assets/img/home/find-your-investment.webp"
        alt=""
        loading="lazy"
      />
      <div class="yellow-logo-overlay-1">
        <img src="../../assets/icons/yellow-logo.svg" alt="" loading="lazy" />
      </div>
    </div>
  </article>

  <article class="text-imgs-container">
    <div class="image-container">
      <img
        src="../../assets/img/home/turnkeyConsulting.webp"
        alt=""
        loading="lazy"
      />
      <div class="logo-overlay">
        <img src="../../assets/icons/green-logo.svg" alt="" loading="lazy" />
      </div>
    </div>
    <div class="text">
      <div class="img-icon">
        <img src="../../assets/icons/green-eye.svg" alt="" loading="lazy" />
      </div>
      <h3>{{ "components.homePage.turnkeyConsulting" | translate }}</h3>
      <p>{{ "components.homePage.weAccompanyYouThroughout" | translate }}</p>
      <button
        class="green-btn"
        (click)="
          this.router.navigate([
            '/' + this.language + '/como-funciona/consulting'
          ])
        "
      >
        <span>{{ "components.homePage.knowTheConsulting" | translate }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </article>

  <article class="text-imgs-container mobile-only">
    <div class="text">
      <div class="img-icon">
        <img
          src="../../assets/icons/yellow-handshake.svg"
          alt=""
          loading="lazy"
        />
      </div>
      <h3>
        {{ "components.homePage.comprehensiveRentalManagement" | translate }}
      </h3>
      <p>
        {{ "components.homePage.weTakeCareDealingsDescription" | translate }}
      </p>
      <button
        class="yellow-btn"
        (click)="
          this.router.navigate([
            '/' + this.language + '/como-funciona/services'
          ])
        "
      >
        <span>{{ "components.homePage.discoverHowItWorks" | translate }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
    <div class="image-container">
      <img
        src="../../assets/img/home/comprehensive-management.webp"
        alt=""
        loading="lazy"
      />
      <div class="text-overlay">
        <h3 class="text-title">
          {{ "components.homePage.services" | translate }}
        </h3>
        <div class="text-list">
          <ul>
            <li>
              <img
                src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/verified-user.svg"
                alt=""
                loading="lazy"
              />
              {{ "components.homePage.tenantSearchAndSelection" | translate }}
            </li>
            <li>
              <img
                src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/hand-with-coins.svg"
                alt=""
                loading="lazy"
              />
              {{ "components.homePage.rentCollectionManagement" | translate }}
            </li>
            <li>
              <img src="../../assets/icons/tool.svg" alt="" loading="lazy" />
              {{
                "components.homePage.incidentAndRepairManagement" | translate
              }}
            </li>
            <li>
              <img
                src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/shield-check.svg"
                alt=""
                loading="lazy"
              />
              {{ "components.homePage.homeAndNonPaymentInsurance" | translate }}
            </li>
          </ul>
        </div>
      </div>
      <div class="yellow-logo-overlay">
        <img src="../../assets/icons/yellow-logo.svg" alt="" loading="lazy" />
      </div>
    </div>
  </article>
</section>

<section class="talk-to-an-expert">
  <div class="expert-container">
    <div
      class="expert-image"
      [style.background-image]="
        'url(' + picturesServer + 'img/home/talk-to-an-expert.jpg)'
      "
    ></div>
    <div class="expert-info">
      <img
        src="{{ picturesServer }}img/home/usuarios@2x.png"
        alt=""
        style="height: 48px; width: 104px"
        loading="lazy"
      />
      <span class="title">{{
        "components.homePage.talkToExpert" | translate
      }}</span>
      <span class="subtitle">{{
        "components.homePage.investmentExpert" | translate
      }}</span>
      <button
        class="btn-expert"
        id="btn-callmeback-header"
        (click)="openCallModal()"
      >
        <img
          src="{{ picturesServer }}img/home/icono-telefono.svg"
          alt="phone icon"
          class="img-phone"
        />
        {{ "components.homePage.weCallYouNow" | translate }}
      </button>
    </div>
  </div>
</section>
<section class="featured-properties">
  <app-properties-preview
    style="max-width: 100%"
    [cardAmount]="4"
    [page]="'home'"
  ></app-properties-preview>
</section>

<section class="lista-links">
  <app-lista-links-home></app-lista-links-home>
</section>

<!-- HubSpot Form Container -->
<!-- <div id="hubspotForm" style="display: none;"></div> -->

<ng-template #exito let-modal>
  <div class="container">
    <div class="col-12" style="padding: 10px 0 20px 0">
      <button type="button" class="close" (click)="closeModalPopUp()">
        &times;
      </button>
      <div class="text-center" style="padding: 20px 0 10px 0">
        <img
          src="favicon.ico"
          width="28"
          height="28"
          loading="lazy"
          alt="logo de inviertis"
        />
        <div
          style="
            margin: 30px 15px 0px 15px;
            text-align: justify;
            font-family: 'Poppins', sans-serif;
            color: #000000;
          "
        >
          <p>
            {{ "components.homePage.hello" | translate }}
            <b>inviertispro.com</b
            >{{ "components.homePage.toOffer" | translate }}
          </p>
          <p>{{ "components.homePage.butWe" | translate }}</p>
        </div>
      </div>
      <div>
        <button class="btn boton-nuevo" (click)="closeModalPopUp()">
          {{ "components.homePage.greatThanks" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
